
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire18e5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire18e5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dizyP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ae88a6e75f1b047$export$2e2bcd8739ae039);

var $6AR8M = parcelRequire("6AR8M");

var $ilpIi = parcelRequire("ilpIi");

var $gCsgB = parcelRequire("gCsgB");

var $68fs9 = parcelRequire("68fs9");

var $eZT5N = parcelRequire("eZT5N");
// Give up on flushing rather than hanging on an unreachable server.
const $9ae88a6e75f1b047$var$FLUSH_TIMEOUT_MS = 5000;
async function $9ae88a6e75f1b047$export$2e2bcd8739ae039(auth) {
    // Read this before signOut, which clears currentUser.
    const email = auth.currentUser?.email;
    // Firestore now keeps the signed-in user's whole document — progress, the
    // name on their certificate, the certificate URL — in IndexedDB, so signing
    // out should clear it rather than leave it readable at rest to the next
    // person on a shared browser.
    //
    // But clearIndexedDbPersistence destroys the pending mutation queue along
    // with the cache, and terminate() does not flush it. Clearing with unsynced
    // answers still queued would silently discard exactly the offline progress
    // the app promises to sync. So the cache is only cleared once those writes
    // are confirmed at the server; otherwise it is left alone and flushes on the
    // next sign-in from this browser.
    //
    // Two things make the flush easy to get wrong:
    //
    // It MUST happen before signOut. Firestore keys its mutation queue per user,
    // so afterwards the queue is the anonymous user's empty one, and
    // waitForPendingWrites would resolve at once on nothing — clearing away the
    // very writes it is meant to protect.
    //
    // And on its own it proves nothing: with an empty queue it resolves at once
    // whether or not there is a network, so it would report success on a plane
    // and clear a cache the user still needs. navigator.onLine is no help either
    // — it is true on a captive portal, which is the whole reason the quiz round
    // has a fallback for that case. So connectivity is established the only way
    // that actually proves it, with a forced round-trip to the server.
    let flushed = false;
    if (email) try {
        await Promise.race([
            (async ()=>{
                await (0, $ilpIi.getDocFromServer)((0, $ilpIi.doc)((0, $gCsgB.db), (0, $eZT5N.USERS), email));
                await (0, $ilpIi.waitForPendingWrites)((0, $gCsgB.db));
            })(),
            new Promise((_, reject)=>setTimeout(()=>reject(new Error("flush timed out")), $9ae88a6e75f1b047$var$FLUSH_TIMEOUT_MS))
        ]);
        flushed = true;
    } catch (error) {}
    try {
        await (0, $6AR8M.signOut)(auth);
    } catch (error) {
        // Reload rather than return: play.js has already disabled the button and
        // changed its text, so returning here leaves it reading "Signing out..."
        // with pointer-events: none and no way back.
        window.location.reload();
        return;
    }
    if (flushed) try {
        await (0, $ilpIi.terminate)((0, $gCsgB.db));
        // Rejects while another tab holds the persistence lease. Keeping the
        // cache is the correct outcome there too.
        await (0, $ilpIi.clearIndexedDbPersistence)((0, $gCsgB.db));
        // Only once the cache is actually gone. The pack is just a list of ids
        // into that cache, so the two are cleared together or kept together —
        // clearing it alone would tell the next offline session it has no
        // questions while 30 playable ones are still sitting there.
        (0, $68fs9.clearPack)(email);
    } catch (error) {}
    // A terminated client cannot be reused, and the page must not keep rendering
    // against one, so reload either way.
    window.location.reload();
}

});
parcelRegister("68fs9", function(module, exports) {

$parcel$export(module.exports, "getPack", () => $476f7a14c884cb42$export$80d07f5c735a39eb);
$parcel$export(module.exports, "clearPack", () => $476f7a14c884cb42$export$178295f95ea335b);
$parcel$export(module.exports, "prunePack", () => $476f7a14c884cb42$export$4a272520164033c3);
$parcel$export(module.exports, "refillPack", () => $476f7a14c884cb42$export$3219c35e1600f2ec);
// Keeps a batch of question documents reachable while offline.
//
// The pack is only a list of question IDs. The question bodies live in
// Firestore's own IndexedDB cache — reading a document once while online is
// what puts it there, so prefetching is just a fan of getDoc calls. Nothing is
// written to Firestore, and no field is added to users/{email}: a new field
// would leave every existing user document without it.
//
// THE PACK IS AN OFFLINE RESERVE AND NOTHING ELSE. Serving a round from it
// while ONLINE, to skip the network, looks like free latency and cannot work:
// getDoc sets waitForSyncWhenOnline, and QueryListener refuses to raise a
// fromCache snapshot unless onlineState is Offline. So an online getDoc waits
// for the server whether or not the document is already sitting in IndexedDB,
// and a warm cache buys nothing at all on the fast path.
//
// This was built and then reverted on a branch that never shipped. It is
// recorded here because it is an obvious idea to have twice, and because the
// code gives no hint that it fails — the reads succeed, they are simply not
// any faster.

var $fkb9T = parcelRequire("fkb9T");

var $j4ygX = parcelRequire("j4ygX");

var $eZT5N = parcelRequire("eZT5N");
const $476f7a14c884cb42$var$PACK_SIZE = 30;
// Refill once the pack is nearly used up rather than every round. At 5
// questions a round that is roughly one refill per four rounds, so the cost is
// ~30 extra Firestore reads per four rounds, not per round.
const $476f7a14c884cb42$var$REFILL_BELOW = 10;
function $476f7a14c884cb42$var$key(email) {
    return `tgmq.offlinePack.${email}`;
}
function $476f7a14c884cb42$export$80d07f5c735a39eb(email) {
    try {
        const stored = JSON.parse(localStorage.getItem($476f7a14c884cb42$var$key(email)));
        return Array.isArray(stored) ? stored : [];
    } catch  {
        // Unset, malformed, or localStorage unavailable (Safari with cookies
        // blocked throws on read). No pack means no offline play, not a crash.
        return [];
    }
}
function $476f7a14c884cb42$export$178295f95ea335b(email) {
    if (!email) return;
    try {
        localStorage.removeItem($476f7a14c884cb42$var$key(email));
    } catch  {
    // localStorage unavailable; there was nothing stored to clear.
    }
}
function $476f7a14c884cb42$export$4a272520164033c3(email, failedIDs) {
    if (failedIDs.length === 0) return;
    $476f7a14c884cb42$var$savePack(email, $476f7a14c884cb42$export$80d07f5c735a39eb(email).filter((id)=>!failedIDs.includes(id)));
}
function $476f7a14c884cb42$var$savePack(email, ids) {
    try {
        localStorage.setItem($476f7a14c884cb42$var$key(email), JSON.stringify(ids));
    } catch  {
    // Private browsing. Offline play is unavailable; online play is unaffected.
    }
}
async function $476f7a14c884cb42$export$3219c35e1600f2ec(db, email, unansweredQnsIDs) {
    const stillUsable = $476f7a14c884cb42$export$80d07f5c735a39eb(email).filter((id)=>unansweredQnsIDs.includes(id));
    if (stillUsable.length >= $476f7a14c884cb42$var$REFILL_BELOW) return;
    const ids = (0, $j4ygX.default)(unansweredQnsIDs).slice(0, $476f7a14c884cb42$var$PACK_SIZE);
    // Reading each document is the point: it populates persistentLocalCache.
    const fetched = await Promise.all(ids.map((id)=>(0, $fkb9T.default)(db, (0, $eZT5N.QUESTIONS), id).then((question)=>question ? id : null).catch(()=>null)));
    // Merge rather than replace. If the connection drops part-way through, every
    // read returns null, and overwriting would wipe a pack whose questions are
    // still sitting in the cache — stranding the user with playable questions the
    // app then refuses to serve.
    const merged = new Set([
        ...stillUsable,
        ...fetched.filter(Boolean)
    ]);
    $476f7a14c884cb42$var$savePack(email, [
        ...merged
    ]);
}

});
parcelRegister("fkb9T", function(module, exports) {

$parcel$export(module.exports, "default", () => $b28161221979253c$export$2e2bcd8739ae039);

var $ilpIi = parcelRequire("ilpIi");
async function $b28161221979253c$export$2e2bcd8739ae039(db, collection, id) {
    const docRef = (0, $ilpIi.doc)(db, collection, id);
    // Deliberately does NOT catch. A read that fails must not become the same
    // null this returns for "no such document": firebaseOnAuthStateChangedWrapper
    // reads null as "first-time user" and calls initializeUser, which would reset
    // a returning user's progress to all questions unanswered. Callers that can
    // tolerate a missing document catch for themselves.
    const docSnap = await (0, $ilpIi.getDoc)(docRef);
    if (docSnap.exists()) // console.log("Document data:", docSnap.data());
    return docSnap.data();
    else // docSnap.data() will be undefined in this case
    return null;
}

});

parcelRegister("j4ygX", function(module, exports) {

$parcel$export(module.exports, "default", () => $de28f9dd7579da39$export$2e2bcd8739ae039);
function $de28f9dd7579da39$export$2e2bcd8739ae039(arr) {
    // Fisher-Yates (aka Knuth) Shuffle from ChatGPT
    let shuffledArray = [
        ...arr
    ];
    for(let i = shuffledArray.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        [shuffledArray[i], shuffledArray[j]] = [
            shuffledArray[j],
            shuffledArray[i]
        ]; // Swap elements
    }
    return shuffledArray;
}

});

parcelRegister("eZT5N", function(module, exports) {

$parcel$export(module.exports, "USERS", () => $aeb17f64c343e87d$export$5a898dd3a28f57e9);
$parcel$export(module.exports, "TIME", () => $aeb17f64c343e87d$export$a9905336c0111a3a);
$parcel$export(module.exports, "QUESTIONS", () => $aeb17f64c343e87d$export$aa473411bddb7e17);
$parcel$export(module.exports, "QUESTIONSIDS", () => $aeb17f64c343e87d$export$46ef321e8bd96549);
$parcel$export(module.exports, "QUESTIONSIDS_DOCID", () => $aeb17f64c343e87d$export$c23be53f670c80b6);
const $aeb17f64c343e87d$export$5a898dd3a28f57e9 = "users"; //users collection in Firestore
const $aeb17f64c343e87d$export$a9905336c0111a3a = 30; //seconds
// PRODUCTION VARIABLES
const $aeb17f64c343e87d$export$aa473411bddb7e17 = "questions"; //questions collection in Firestore
const $aeb17f64c343e87d$export$46ef321e8bd96549 = "questionsIDs"; //questionsIDs collection in Firestore
const $aeb17f64c343e87d$export$c23be53f670c80b6 = "D5lrnjJzMmgtQb9Rs7WI"; //doc id of the only document in questionsIDs collection

});



parcelRegister("rgaJJ", function(module, exports) {

$parcel$export(module.exports, "takeRedirectPending", () => $051f112ff699701b$export$40ee86c041ef393e);
$parcel$export(module.exports, "default", () => $051f112ff699701b$export$2e2bcd8739ae039);

var $6AR8M = parcelRequire("6AR8M");

var $b0m9P = parcelRequire("b0m9P");

var $7eLLW = parcelRequire("7eLLW");

var $17UA5 = parcelRequire("17UA5");
// A redirect sign-in that fails does NOT reject. When the SDK cannot read its
// pending state back — third-party storage partitioned away, the user
// abandoning the Google screen — getRedirectResult simply resolves null, which
// is indistinguishable from an ordinary first page load. This marker is what
// makes the difference visible: set on the way out, checked on the way back.
//
// sessionStorage survives the cross-origin round trip because it stays in the
// same tab, and is scoped to it, so a second tab cannot see a stale flag.
const $051f112ff699701b$var$REDIRECT_PENDING_KEY = "tgmq.redirectPending";
function $051f112ff699701b$var$markRedirectPending() {
    try {
        sessionStorage.setItem($051f112ff699701b$var$REDIRECT_PENDING_KEY, "1");
    } catch  {
    // Storage blocked. The redirect may still work; only the diagnostic is lost.
    }
}
function $051f112ff699701b$export$40ee86c041ef393e() {
    try {
        const pending = sessionStorage.getItem($051f112ff699701b$var$REDIRECT_PENDING_KEY);
        sessionStorage.removeItem($051f112ff699701b$var$REDIRECT_PENDING_KEY);
        return !!pending;
    } catch  {
        return false;
    }
}
// Re-enable the button play.js disabled on click, so a failed sign-in can be
// retried. Without it the button keeps pointer-events: none until a reload.
function $051f112ff699701b$var$releaseSignInButton() {
    const signInBtn = document.getElementById("sign-in-with-google");
    if (signInBtn) signInBtn.disabled = false;
}
function $051f112ff699701b$var$logAuthError(error, GoogleAuthProvider) {}
function $051f112ff699701b$export$2e2bcd8739ae039(auth, GoogleAuthProvider, onFailure = ()=>{}) {
    const provider = new GoogleAuthProvider();
    // In an installed app, signInWithPopup hangs for ever.
    //
    // It works by opening the Firebase auth handler with window.open and waiting
    // for that window to postMessage the result back through window.opener. An
    // installed app has no opener relationship with the window it opens — the URL
    // is handed to a separate browser context — so the message never arrives, the
    // promise never settles, and the button just sits disabled with no error to
    // show. Redirect keeps the whole flow in this one context.
    //
    // Applied to every installed display mode, not just Android's: redirect is
    // equally correct wherever popup would have worked, so there is nothing to
    // gain from a narrower test.
    //
    // Success is picked up by the onAuthStateChanged observer on the way back in.
    // getRedirectResult in play.js only exists to surface a failed return.
    //
    // Production only, and the isProductionHost() half is load-bearing for local
    // development. The redirect flow needs the real Firebase auth handler served
    // same-origin through the /__/* proxy in netlify.toml. Neither exists on a
    // dev server, so against the Auth emulator the round trip always returns with
    // getRedirectResult resolving null — which play.js correctly reports as
    // "Sign-in was not completed", leaving local sign-in impossible for anyone
    // whose browser reports a standalone display mode. The popup path has no such
    // dependency and works against the emulator, so local dev always takes it.
    //
    // This changes nothing in production: isProductionHost() is true there, so
    // an installed app still gets the redirect it needs.
    if ((0, $b0m9P.default)() && (0, $7eLLW.default)()) {
        // No sign_in_click here. logEvent waits on the analytics SDK's own init
        // promise and signInWithRedirect unloads the page on the same tick, so on a
        // cold start the event would never leave the device — while the
        // sign_in_success on the way back always sends. That is a funnel with a
        // numerator and no denominator, and a conversion rate above 100%.
        //
        // play.js logs it on the way back instead, off the marker set below, which
        // already survives this navigation. See the note there for what that
        // measures and what it cannot.
        $051f112ff699701b$var$markRedirectPending();
        (0, $6AR8M.signInWithRedirect)(auth, provider).catch((error)=>{
            // Only reached if the navigation never starts; otherwise the page is gone.
            $051f112ff699701b$export$40ee86c041ef393e();
            $051f112ff699701b$var$releaseSignInButton();
            $051f112ff699701b$var$logAuthError(error, GoogleAuthProvider);
            // The click has to be logged here too. play.js replays it off the marker
            // above, but only on the way back, and this attempt never leaves. Without
            // it this failure has no click to divide into and the redirect failure
            // rate reads over 100%. The page is not unloading here, so it sends.
            (0, $17UA5.default)("sign_in_click", {
                method: "redirect"
            });
            onFailure(error, "redirect");
        });
        return;
    }
    // The popup path never unloads the page, so this one is reliable, and it is
    // the path almost all traffic takes.
    (0, $17UA5.default)("sign_in_click", {
        method: "popup"
    });
    (0, $6AR8M.signInWithPopup)(auth, provider).then((result)=>{
        // The popup half of sign_in_success. This resolves only after a real
        // attempt, unlike the auth observer, which also fires on every page load
        // of an already-signed-in user — put the event there and the ratio to
        // sign_in_click climbs past 100% and stops meaning anything.
        (0, $17UA5.default)("sign_in_success", {
            method: "popup"
        });
        const user = result.user;
    }).catch((error)=>{
        $051f112ff699701b$var$releaseSignInButton();
        $051f112ff699701b$var$logAuthError(error, GoogleAuthProvider);
        // Closing the popup yourself is a normal thing to do and is not worth a
        // banner; anything else is a failure the user cannot otherwise see.
        if (error?.code !== "auth/popup-closed-by-user") onFailure(error, "popup");
        else (0, $17UA5.default)("sign_in_abandoned", {
            method: "popup"
        });
    });
}

});

parcelRegister("5i2OU", function(module, exports) {

$parcel$export(module.exports, "default", () => $3da0d2317cc886da$export$2e2bcd8739ae039);

var $ilpIi = parcelRequire("ilpIi");

var $iIuFd = parcelRequire("iIuFd");
const $3da0d2317cc886da$var$FAILED_WRITE_ID = "writeFailureMessage";
// One banner however many writes fail. A player who loses one write is very
// likely about to lose the next, and stacking a red bar per question would bury
// the quiz under its own error messages.
//
// The wording stays vague about what was lost on purpose. This wrapper carries
// answers, quizCompletedOn and the whole initial user document, so "answers may
// need to be repeated" would be wrong for two of its three callers. Telling the
// player to reload and check is true for all of them.
//
// The error code is in the message because there is nowhere else for it to go.
// .babelrc strips every console.* call in every environment, and this app has no
// error reporting, so on a real device the code below reaches nobody. Without it
// permission-denied, invalid-data and an expired token are indistinguishable in
// a bug report.
function $3da0d2317cc886da$var$reportFailedWrite(error) {
    if (document.getElementById($3da0d2317cc886da$var$FAILED_WRITE_ID)) return;
    const code = error?.code ? ` (${error.code})` : "";
    const messageEl = (0, $iIuFd.default)(`Some of your progress could not be saved${code}. Please reload the page to check what was recorded.`);
    messageEl.id = $3da0d2317cc886da$var$FAILED_WRITE_ID;
    const body = document.querySelector("body");
    body.insertBefore(messageEl, body.firstChild);
}
function $3da0d2317cc886da$export$2e2bcd8739ae039(db, collectionName, userDocumentID, userData) {
    const userRef = (0, $ilpIi.doc)(db, collectionName, userDocumentID);
    const write = (0, $ilpIi.setDoc)(userRef, {
        ...userData
    }, {
        merge: true
    });
    write.catch((error)=>{
        $3da0d2317cc886da$var$reportFailedWrite(error);
    });
    return write;
}

});

parcelRegister("2SeC6", function(module, exports) {

$parcel$export(module.exports, "default", () => $217bf5e1cdb0b807$export$2e2bcd8739ae039);
// Firebase imports
// import { collection, getDocs } from "firebase/firestore";

var $ilpIi = parcelRequire("ilpIi");

var $5i2OU = parcelRequire("5i2OU");

var $eZT5N = parcelRequire("eZT5N");
async function $217bf5e1cdb0b807$export$2e2bcd8739ae039(db, collectionName, user) {
    let unansweredQnsIDs = []; // unansweredQnsIDs will contain doc ids of each question
    const docRef = (0, $ilpIi.doc)(db, (0, $eZT5N.QUESTIONSIDS), (0, $eZT5N.QUESTIONSIDS_DOCID));
    const docSnap = await (0, $ilpIi.getDoc)(docRef);
    if (docSnap.exists()) unansweredQnsIDs = [
        ...docSnap.data().questionsIDsArr
    ];
    let userDocumentID = user.email; // each user is a document. user's email will be used as user's document ID
    let userData = {
        totalQnsInMainCollection: unansweredQnsIDs.length,
        unansweredQnsIDs: unansweredQnsIDs,
        //initially a copy of master database, this will decrement as the user keeps giving correct answers
        totalCorrect: 0,
        //incremented each time a user answers correctly
        totalAttempts: 0,
        //incremented each time a user attempts question
        quizCompletedOn: null,
        //date and time user completed the quiz
        certificate: {
            issued: false,
            issuedTo: null,
            //display name on certificate
            dateIssued: null,
            url: null //if issued, this will store the link on Firebase cloud storage
        }
    };
    (0, $5i2OU.default)(db, collectionName, userDocumentID, userData);
}

});


//# sourceMappingURL=sahasranamaAccount.b3774404.js.map
